//
// import './App.css';
// import Forgeviewer from './forgeviewer'
// import './forgeviewer.css'
// function App() {
//   return (
//       <Forgeviewer url={"https://viewertestbucket.s3.us-east-2.amazonaws.com/bubble.json"} />
//   );
// }

// export default App;
import React from 'react';
import './App.css';
import './forgeviewer.css'
import Forgeviewer from './forgeviewer'

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const designId = urlParams.get('design') || 'design'; // Replace 'defaultDesignId' with a sensible default if necessary

  const url = `https://cdn.pwiworks.com/viewer/${designId}/Viewer3D/bubble.json`;
  console.log(url);
  return (
      <Forgeviewer url={url} />
  );
}
export default App;

